import DeleteWithAsking from ".";
import { useAuth } from "$context/AuthContextProvider";
import { useDelete } from "./queries";

const DeleteDataBase = ({ isLoading, setLoadingComponent }) => {
  const { municipalUtility } = useAuth();
  const deleteMutation = useDelete(
    `/municipal_utility/${municipalUtility}/delete_customers`,
    setLoadingComponent
  );

  return (
    <DeleteWithAsking
      titleText={"Sicherheitsnachfrage"}
      descriptionText={
        "Vergewissern Sie sich, dass Sie die Daten exportiert haben, bevor Sie die Datenbank löschen! Diese Aktion ist nicht umkehrbar!"
      }
      buttonText={"Daten löschen"}
      mutationFn={deleteMutation}
      isLoading={isLoading}
    />
  );
};

export default DeleteDataBase;
